import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import SamplesModelDialog from "./SamplesModelDialog.vue";
import jslinq from "jslinq";
import hideMobileKeyboardOnReturn from "../plugins/utils";
import ItemsCarousel from "@/components/ItemsCarousel.vue";
import config from "@/config/custom-config";
// import {Waypoint} from 'vue-waypoint'
let ColoriFrontali = class ColoriFrontali extends Vue {
  constructor() {
    super(...arguments);
    this.defaultColor = null;
    this.itemsType = "coloriFrontali";
    this.noImageColor = [];
    this.ecoColors = false;
    this.searchQuery = "";
    this.category = [];
    this.animateColors = false;
    this.hoverWarning = false;
    this.showSampleDialog = false;
    this.selectedFinishings = "";
    this.giacWarning = false;
    this.giacWarningMessage = "";
    this.scrolling = false;
    this.showLeftButton = false;
    this.showRightButton = false;
    this.scrollCounter = 0;
    this.finituraOptions = [];
    this.defaultColorFinishingCodes = ["NESSUNO", "N", "M", "S"];
  }
  get translatedFinishingLabels() {
    return {
      NESSUNO: this.$t("message.Lucido"),
      S: this.$t("message.Lucido"),
      N: this.$t("message.Naturale"),
      M: this.$t("message.Opaco")
    };
  }
  async mounted() {
    await this.getColors();
    this.setupColorFinishingOptions();
    this.syncTintaUnitaVisibility();
  }
  onTranslationLabelsChange() {
    this.setupColorFinishingOptions();
  }
  hideMobileKeyboardOnReturn(e) {
    hideMobileKeyboardOnReturn(e);
  }
  get config() {
    return config;
  }
  get filteredTemples() {
    return this.$store.state.filteredTemples;
  }
  get categories() {
    return jslinq(this.colori).select(c => c.Category).distinct().toList();
  }
  get tintaUnita() {
    return this.$store.state.tintaUnita;
  }
  set tintaUnita(newVal) {
    this.$store.commit("setTintaUnita", newVal);
  }
  get filteredColors() {
    let q = this.searchQuery;
    let c = this.category;
    let result = this.colori;
    if (q) {
      result = result.filter(color => {
        return _.includes(color === null || color === void 0 ? void 0 : color.PLASTICA, q);
      });
    }
    if (!_.isEmpty(c)) {
      if (result) {
        result = result.filter(color => {
          return c.indexOf(color === null || color === void 0 ? void 0 : color.Category) >= 0;
        });
      }
    }
    if (this.ecoColors) {
      result = result.filter(color => {
        return color.U_THE_COLORE.indexOf("EP") >= 0;
      });
    }
    if (this.tintaUnita) {
      result = result.filter(color => {
        return this.filteredTemples.some(t => {
          return t.U_THE_COLORE === color.U_THE_COLORE;
        });
      });
    }
    return _.difference(result, this.noImageColor);
  }
  get temples() {
    const aste = this.$store.state.configurator.aste.allColors;
    return aste;
  }
  set temples(newVal) {
    this.$store.commit("configurator/aste/setAllColors", newVal);
  }
  get finitura() {
    return this.$store.state.configurator.finitura;
  }
  set finitura(newVal) {
    this.finishing = newVal;
  }
  get finishing() {
    if (this.finitura) {
      return this.finitura;
    } else {
      return "S";
    }
  }
  set finishing(f) {
    var _this$frontale;
    this.$store.commit("configurator/setFinishing", f);
    const tecnologia = (_this$frontale = this.frontale) === null || _this$frontale === void 0 ? void 0 : _this$frontale.U_THE_TECNOLOGIA;
    if (this.tintaUnita || tecnologia === "AFF") {
      this.$store.commit("configurator/setTemplesFinishing", f);
    }
  }
  get finituraSelection() {
    return this.finitura === "S" ? "NESSUNO" : this.finitura;
  }
  set finituraSelection(newVal) {
    this.finishing = newVal === "NESSUNO" ? "S" : newVal;
  }
  get allowedColorFinishCodes() {
    const raw = this.config.colori_finiture_codes;
    if (!Array.isArray(raw) || raw.length === 0) {
      return ["S", "N", "M"];
    }
    const normalized = raw.map(code => String(code || "").trim().toUpperCase()).filter(code => this.defaultColorFinishingCodes.includes(code)).map(code => code === "NESSUNO" ? "S" : code);
    return Array.from(new Set(normalized));
  }
  setupColorFinishingOptions() {
    const labels = this.translatedFinishingLabels;
    const raw = this.config.colori_finiture_codes;
    const configuredCodes = Array.isArray(raw) && raw.length > 0 ? raw.map(code => String(code || "").trim().toUpperCase()).filter(code => this.defaultColorFinishingCodes.includes(code)) : [...this.defaultColorFinishingCodes];
    const normalizedDisplayCodes = Array.from(new Set(configuredCodes.map(code => code === "S" ? "NESSUNO" : code)));
    this.finituraOptions = normalizedDisplayCodes.map(code => ({
      id: code,
      text: labels[code] || code
    }));
    this.ensureValidColorFinishingSelection();
  }
  ensureValidColorFinishingSelection() {
    const allowedIds = this.finituraOptions.map(item => item.id);
    if (allowedIds.length === 0) return;
    if (!allowedIds.includes(this.finituraSelection)) {
      this.finituraSelection = allowedIds[0];
    }
  }
  getColorFinishCode(color) {
    const code = String((color === null || color === void 0 ? void 0 : color.U_THE_FINITURA) || "").trim();
    if (code === "S" || code === "N" || code === "M") return code;
    return "S";
  }
  get colore() {
    return this.$store.state.configurator.colore.U_THE_COLORE;
  }
  get color() {
    return this.$store.state.configurator.colore.U_THE_COLORE;
  }
  get finituraAste() {
    return this.$store.state.configurator.finituraAste;
  }
  get frontale() {
    return this.$store.state.configurator.frontale;
  }
  get coloreActive() {
    const colore = this.$store.state.configurator.colore;
    if (colore) {
      return colore.ItemCode;
    } else {
      console.warn("frontale is null or undefined");
      return null;
    }
  }
  set colore(c) {
    if (parseInt(c.GiacIta) < 1) {
      this.giacWarning = true;
      this.giacWarningMessage = this.$t('message.Il_colore_{color}_è_esaurito,_data_di_arrivo:_{date}', {
        color: c.U_THE_COLORE,
        date: this.formatDate(new Date(c.ShipDateIta))
      }).toString();
    }
    this.$store.commit("configurator/setColore", c);
  }
  get colori() {
    return this.$store.state.configurator.frontali.colors;
  }
  get canOrderColorSample() {
    return this.$store.getters["canOrderColorSample"];
  }
  get coloreAste() {
    return this.$store.state.configurator.coloreAste;
  }
  formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  getColors() {
    return this.$store.dispatch("configurator/frontali/getColors");
  }
  coloreSelected(col) {
    if (parseInt(col.GiacIta) < 1 && !col.ShipDateIta) {
      return;
    }
    const corresponding = this.filteredTemples.find(temple => temple.U_THE_COLORE == (this.tintaUnita ? col.U_THE_COLORE : this.coloreAste.U_THE_COLORE) && temple.misura == (this.coloreAste ? this.coloreAste.U_THE_LUNGASTA : "145"));
    if (corresponding) {
      this.$store.commit("configurator/setTemplesColor", corresponding);
    }
    this.colore = col;
  }
  colorImageUrl(colore) {
    if (colore && colore.Category != "MULTISTRATO") {
      return colore.imageUrl;
    }
    if (colore) {
      return colore.imageUrl;
    }
    return "";
  }
  removeChip(item) {
    const index = this.category.indexOf(item);
    if (index !== -1) {
      this.category.splice(index, 1);
    }
  }
  isActive(c) {
    return this.colore == c;
  }
  removeCategoryItem(item) {
    _.pull(this.category, item);
  }
  noImageError(c) {
    this.noImageColor.push(c);
  }
  loadImageUrl(w) {
    let e = w.el;
    let src = w.el.dataset.src;
    if (w.going.toLowerCase() === "in") {
      e.src = src;
    }
  }
  onRevealSettingChanged(newVal) {
    if (newVal == "frontColor") {
      let self = this;
      this.animateColors = true;
      setTimeout(function () {
        self.animateColors = false;
        self.$emit("reset-setting-item");
      }, 2000);
    }
  }
  onColoriFinitureCodesChanged() {
    this.setupColorFinishingOptions();
  }
  onColoriTintaUnitaChanged() {
    this.syncTintaUnitaVisibility();
  }
  syncTintaUnitaVisibility() {
    if (!this.config.colori_tinta_unita && this.tintaUnita) {
      this.tintaUnita = false;
    }
  }
};
__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "darkTheme", void 0);
__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "isOpen", void 0);
__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "revealSetting", void 0);
__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "expanded", void 0);
__decorate([Watch('translatedFinishingLabels')], ColoriFrontali.prototype, "onTranslationLabelsChange", null);
__decorate([Watch("revealSetting")], ColoriFrontali.prototype, "onRevealSettingChanged", null);
__decorate([Watch("config.colori_finiture_codes", {
  deep: true
})], ColoriFrontali.prototype, "onColoriFinitureCodesChanged", null);
__decorate([Watch("config.colori_tinta_unita")], ColoriFrontali.prototype, "onColoriTintaUnitaChanged", null);
ColoriFrontali = __decorate([Component({
  components: {
    SamplesModelDialog,
    ItemsCarousel
  },
  filters: {
    upper(val) {
      return _.upperCase(val);
    },
    capitalize: str => {
      return _.capitalize(str);
    }
  }
})], ColoriFrontali);
export default ColoriFrontali;